export default "__VITE_ASSET__5cdc56bc__"